export type IntegrationCalendarSelection = {
    integrationId: number;
    calendarId: string;
};

export function serializeIntegrationCalendarSelection(
    integrationId: number,
    calendarId: string | number,
): string {
    return JSON.stringify({
        integrationId,
        calendarId: calendarId.toString(),
    });
}

export function deserializeIntegrationCalendarSelection(
    value: string,
): IntegrationCalendarSelection | null {
    try {
        const parsed = JSON.parse(value);
        if (
            typeof parsed?.integrationId !== "number" ||
            typeof parsed?.calendarId !== "string"
        ) {
            return null;
        }
        return parsed as IntegrationCalendarSelection;
    } catch {
        return null;
    }
}
